import React from 'react';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import PropTypes from 'prop-types';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

export const TruncatedBox = React.forwardRef(({ children, isTruncated, maxContentHeightWhenTruncating }, ref) => {
  const theme = useTheme();

  let boxProps = {
    transition: theme.transitions.create('max-height', {
      duration: 400,
    }),
    // We don't ever expect this box to actually get this big, but this is a workaround for a quirk of css transition animations.
    // You can't transition between a fixed height and height 100% because it needs to be able to calculate the transition duration
    // beforehand and it can't do that without a fixed value. Using maxHeight allows us to still use a transition while setting
    // the height itself to 100%.
    maxHeight: '2000px',
    height: '100%',
  };
  if (isTruncated) {
    // We will truncate description content that is too long by fading the text to transparent and hiding the overflow
    boxProps = {
      'overflow-y': 'hidden',
      '-webkit-mask-image': 'linear-gradient(to bottom, black 80%, transparent 100%)',
      'mask-image': 'linear-gradient(to bottom, black 80%, transparent 100%)',
      maxHeight: `${maxContentHeightWhenTruncating}px`,
      height: `${maxContentHeightWhenTruncating}px`,
      transition: theme.transitions.create('max-height', {
        duration: theme.transitions.duration.standard,
      }),
    };
  }

  return (
    <Box
      ref={ref}
      sx={{
        ...boxProps,
      }}
    >
      {children}
    </Box>
  );
});

TruncatedBox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  isTruncated: PropTypes.bool.isRequired,
  maxContentHeightWhenTruncating: PropTypes.number.isRequired,
};
